module.exports = __webpack_public_path__ + "img/image-mt-5.dedfa570.png";